module.exports = __webpack_public_path__ + "media/promo/hochland/images/ball3-d156bd40a3cec69659e9e52ea8b78020.png";